//const api='http://47.94.36.204';  // 测试地址
const api = "http://gdovoffice.com"; // 正式地址

// 不需要登录的接口
module.exports = {
  // 七牛图片路径 在会员中心首页有用到
  IMG_URL: "http://images.kxymall.com/", //正式环境
  IMG_URL_TEST: "http://images-test.kxymall.com", //测试环境
  //storeURL: 'http://47.94.36.204/api/web/personal/seller', // 测试商家管理中心地址
  storeURL: "http://seller.kxymall.com/templates/login.html", // 正式商家管理中心地址
  sellerDevelopURL: "http://seller-test.kxymall.com", // 开发环境卖家系统管理中心地址
  sellerPrepareURL: "http://seller-prepare.kxymall.com/", // 预发环境卖家系统管理中心地址
  sellerProductURL: "http://seller.kxymall.com", // 线上卖家系统管理中心地址
  // 结算系统注册跳转  在公共头部文件 和登录页面有用到
  MOBILE_REG: `${api}/mobileapi/register/userRegister`,
  H5_DEV_URL: "http://m-qa.kxymall.com/m5/", // h5 测试环境服务地址
  H5_PRE_URL: "https://m-prepare.kxymall.com/m5/", // h5 预发环境服务地址
  H5_PRO_URL: "https://m.kxymall.com/m5/", // h5 生产环境服务地址

  SETTLEMENT_HIGH: [         // 高并发商品详情
    "/api/goods/goodsInfo/list",
    "/api/userBehaviors"
  ],

  SELLER_PATH: [    // 卖家申请联盟商家
    "/api/member-league/applyLeague",
    "/api/member-league/findLeagueInfo",
    "/api/member-league/reApplyLeague",
    "/api/member-league/modifyMemberLeague",
    "/api/member-league/isApply",
    "/api/member-league/findLegionList",
    "/v1/api/region/listJsonByPrimaryKey",
    "/v1/api/basket/legions/getUserLegionInfo"
  ],

  GUEST_PATHS: [
    "/pc/index/activity",
    "/api/member/updatePwdByCode",
    "/api/member/updatePayPwdByCode",
    "/api/phone/noLoginSid",
    "/api/phone/region/list",
    "/api/phone/region/detail/list",
    "/api/phone/largeArea/list",
    "/api/goodsCategory/categoryList",
    "/api/indexpage/index",
    "/pc/index/header",
    "/pc/index/home",
    "/pc/index/notEnoughShopping",
    "/pc/index/landmark/premium",
    "/pc/index/self/living/center",
    "/pc/index/gold/shop",
    "/pc/index/enterpriseBrand",
    "/pc/index/personal/shop",
    "/pc/index/zgNiceGoods",
    "/pc/index/enterprise/brand/shop",
    "/pc/index/more/shops",
    "/api/store/storeList_type",
    "/pc/index/article",
    "/api/index/goods/banner",
    "/pc/goods/search",
    "/pc/goods/search4Tree",
    "/pc/store/getStoreCategoryByStoreId",
    "/pc/store/img",
    "/pc/store/tag",
    "/pc/store/index",
    "/pc/store/search",
    "/pc/store/detail",
    "/api/goods/isDelivery",
    "/api/goods/sales/list",
    "/api/goods/search",
    "/api/goods/tagGoods/list",
    "/api/goods/comment/list",
    "/api/goods/zyIndexV2",
    "/api/goods/farmProduct/list",
    "/api/goods/suggestGoodsList",
    "/api/goods/zhlzh",
    "/api/goods/queryGoodsByProvince",
    "/api/goods/couponActive",
    "/api/goods/zhlzhGoods",
    "/api/index/web/menuActiveGoods",
    "/pc/index/classification/zone",
    "/api/store/store_detail",
    "/api/store/localStore/list",
    "/api/index/allReturnZone",
    "/api/index/getSpecialPriceGoods",
    "/api/goods/searchNonDirectGoods",
    "/api/exchangeGoods/getExchangeGoods",
    "/api/index/menuActiveGoods",
    "/api/index/classificationGoods",
    "/api/league/queryStoreCat",
    "/api/store/search"
  ],
  //会员信息接口
  MEMBER_PATHS: [
    "/api/shoppingCart/delete",
    "/api/phone/loginOut",
    "/api/phone/login",
    "/api/phone/register",
    "/api/shoppingCart/list",
    "/api/shoppingCart/add",
    "/api/shoppingCart/update",
    "/api/shoppingCart/clean",
    "/api/cart/check",
    "/api/order/getShipping",
    // '/api/common/upload',
    "/api/member/upload/headLogo",
    "/api/collection/list",
    "/api/collection/delete",
    "/api/collection/save",
    "/api/collection/list",
    "/api/member/comment/save",
    "/api/phone/registerNew",
    "/api/member/improveMemberInfo",
    "/api/member/myGrowth",
    "/api/member/getMemberInfo",
    "/api/member/getVerificationCode",
    "/api/member/updatePwd",
    "/api/member/address/list",
    "/api/member/address/save",
    "/api/banks/getBankList",
    "/api/banks/getBankBranchList",
    "/api/member/address/update",
    "/api/member/addressUpdate",
    "/api/member/address/delete",
    "/api/member/getSignInfo",
    "/api/member/addSignInfo",
    "/api/member/moneyRecord",
    "/api/member/comment/isComment",
    "/api/personal/doLuckydip",
    "/api/personal/luckydipTimesByType",
    "/api/personal/myComment",
    "/api/personal/statistics",
    "/api/personal/recommend",
    "/api/personal/pointList",
    "/api/personal/pointFreezeList",
    "/api/personal/myAsk",
    "/api/personal/withdrawUserInfo/get",
    "/api/personal/userWithdrawAlipay",
    "/api/personal/consumeConfirm",
    "/api/personal/userWithdrawBanks",
    "/api/league/findMemberLeague",
    "/api/league/modifyMemberLeague",
    "/api/league/applyLeague",
    "/api/league/reApplyLeague",
    "/api/league/updateXYInfoById",
    "/api/personal/account/Information",
  ],
  //订单信息接口
  ORDER_PATHS: [
    "/api/cart/payment_list",
    "/api/cart/checkCart",
    "/api/order/getOrderPayInfo",
    "/api/order/getShipping",
    "/api/order/createOrderCart",
    "/api/order/createOrderBuyNow",
    "/api/cart/cartCheck",
    "api/cart/show_payment",
    "/api/order/getOrderItem",
    "/api/returnOrder/getItem",
    "/api/returnOrder/apply",
    "/api/returnOrder/cancelApply",
    "/api/order/confirmReceipt",
    "/api/order/beforeCancelOrder",
    "/api/order/cancelOrder",
    "/api/order/receivingGoodsDelay",
    "/api/returnOrder/list",
    "/api/order/getOrderPayInfo",
    "/api/order/getOrderPayInfo",
    "/api/returnOrder/updateLogistics",
    "/api/logistics/list",
    "/api/logistics/getTrackInfo",
    "/api/order/checkOrderAlreadyPay",
    "/api/order/pay",
    "/api/pay/paymentStatus/get",
    "/api/pay/gdPay",
    "/api/recharge/integral",
    "/api/recharge/weixinSign",
    "/api/order/list",
    "/api/pay/rechargePay",
    "/api/order/count",
  ],
  //订单信息接口
  SETTLE_PATHS: [
    "/api/user/transfer",
    "/api/user/consumeConfirm",
    "/api/user/showAccount",
    "/api/user/getBeingExpiredDeposit",
    "/apiUser/apiUpdateUserpwd",
    "/api/order/selectTransactionDetails",
    "/api/order/selectRedemptionTransactionDetails",
    "/apiUser/calGoldWithdraw",
    "/apiUser/userWithdrawAlipay",
    "/api/order/checkBusinessCentre",
    "/apiUser/showShopownerReflectUserInfo",
  ],
  //需要header加密并加token的接口
  TOKEN_PATHS: [
    "/api/shoppingCart/delete",
    "/api/pay/paymentStatus/get",
    "/api/pay/gdPay",
    "/api/shoppingCart/add",
    "/api/cart/check",
    "/api/shoppingCart/list",
    "/api/shoppingCart/clean",
    "/api/cart/cartCheck",
    "/api/shoppingCart/update",
    "/api/member/checkBusinessCenter",
    "/api/common/upload",
    "/api/league/findMemberLeague",
    "/api/league/modifyMemberLeague",
    "/api/league/applyLeague",
    "/api/league/reApplyLeague",
    "/api/league/updateXYInfoById",
    "/apiUser/apiUpdateUserpwd",
    "/api/user/consumeConfirm",
    "/api/phone/login",
    "/api/phone/loginOut",
    "/api/phone/register",
    "/api/member/improveMemberInfo",
    "/api/order/list",
    "/api/order/getOrderItem",
    "/api/order/confirmReceipt",
    "/api/returnOrder/getItem",
    "/api/returnOrder/apply",
    "/api/returnOrder/cancelApply",
    "/api/order/getOrderPayInfo",
    "api/order/orderCancel",
    "/api/order/selectTransactionDetails",
    "/api/order/selectRedemptionTransactionDetails",
    "/apiUser/calGoldWithdraw",
    "/api/user/transfer",
    "/apiUser/userWithdrawAlipay",
    "/api/order/checkBusinessCentre",
    "/api/personal/statistics",
    "/api/personal/pointList",
    "/api/personal/pointFreezeList",
    "/api/personal/myComment",
    "/api/personal/myAsk",
    "/api/member/getVerificationCode",
    "/api/personal/userWithdrawBanks",
    "/api/recharge/weixinSign",
    "/api/member/getMemberInfo",
    "/api/member/address/list",
    "/api/member/address/save",
    "/api/member/address/update",
    "/api/member/address/delete",
    "/api/member/getSignInfo",
    "/api/member/addSignInfo",
    "/api/personal/withdrawUserInfo/get",
    "/apiUser/showShopownerReflectUserInfo",
    "/api/member/comment/save",
    "/api/member/comment/isComment",
    "/api/collection/save",
    "/api/collection/list",
    "/api/collection/delete",
    "/api/collection/list",
    "/api/pay/rechargePay",
    "/api/order/getShipping",
    "/api/cart/checkCart",
    "/api/order/createOrderCart",
    "/api/order/createOrderBuyNow",
    "/api/order/beforeCancelOrder",
    "/api/user/showAccount",
    "/api/user/getBeingExpiredDeposit",
    "/api/goods/comment/list",
    "/pc/store/getStoreCategoryByStoreId",
    "/api/goodsCategory/categoryList",
    "/api/index/getSpecialPriceGoods",
    "/api/goods/sales/list",
    "/api/goods/isDelivery",
    "/api/goods/tagGoods/list",
    "/api/goods/farmProduct/list",
    "/api/phone/largeArea/list",
    "/api/index/goods/banner",
    "/pc/store/img",
    "/pc/store/tag",
    "/pc/store/detail",
    "/api/order/cancelOrder",
    "/api/order/receivingGoodsDelay",
    "/api/returnOrder/list",
    "/api/returnOrder/updateLogistics",
    "/api/logistics/list",
    "/api/order/checkOrderAlreadyPay",
    "/api/logistics/getTrackInfo",
    "/pc/index/more/shops",
    "/api/store/storeList_type",
    "/api/exchangeGoods/getExchangeGoods",
    "/api/goods/goodsInfo/list",
    "/api/userBehaviors",
    "/api/order/count",
  ],
  // 结算重构接口  2021-9-15  李志远
  SETTLEMENT_PATHS: [
    "/api/client/wallet/listCodePayDetail", // 查询会员积分交易明细列表    已验证
    "/api/client/user/verifyPayPassword", // 校验支付密码   已验证
    "/api/client/common/login", // 结算中心登录接口    已验证
    "/api/client/user/getBusinessCenter", // 商务中心校验   已验证
    "/api/client/wallet/getUserDeposit", // 结算重构  查询会员信息[根据会员编号查询会员信息]   已验证
    "/api/client/wallet/getUserBonusAfterTaxMoney", // 查询会员奖金税后金额[查询会员奖金税后金额]  已验证
    "/api/client/wallet/convertPoint", // 积分兑换[积分兑换   已验证
    "/api/client/wallet/getExtractionCashInfo", //查询会员提现相关信息[查询会员提现相关信息（银行卡信息、身份证信息、银行列表、问题列表等）]  已验证
    "/api/client/wallet/applyWithdraw", // 申请提现（支付宝）[使用支付密码申请提现到支付宝（body加密）]  已验证
    "/api/client/wallet/getWillExpiredDeposit", // 查询会员即将过期积分   已验证
    "/api/client/user/getUserInfo", // 根据loginName查询用户信息  已验证
    "/api/client/user/updatePwdByCode", // 修改登录密码   已验证
    "/api/client/common/logout", // 退出   已验证
    "/api/client/common/validate/getCode", // 获取验证码 (登录)  已验证
    "/api/client/common/sendMessage", // 获取验证码 (未登录)  已验证
    "/api/client/common/userRegister", // 用户注册  已验证
    "/api/client/wallet/listMustIntegralFlow",
    "/api/client/user/getMemberLevel", // 获取用户等级接口
    "/api/client/user/getNoLoginUserInfo", // 获取用户信息（非登陆接口）
    "/api/client/user/updateLegionSn", // 设置用户军团信息
    "/api/client/user/resetPwd", // 重置密码
    "/api/client/user/isExistLoginName", // 校验用户是否存在
    "/api/client/bindCard/sendBindCard", // 发送绑卡信息
    "/api/client/bindCard/bindCardVerify", // 绑卡验证
    "/api/client/bindCard/list", // 卡列表
    "/api/client/bindCard/defaultCard", // 设置默认卡
    "/api/client/bindCard/unBind", // 解绑
    "/api/client/bindCard/getAcctName", // 返回持卡人名字
    "/api/client/bindCard/payVerify", // 支付验证
  ],
};



// WEBPACK FOOTER //
// ./src/utils/url.js